
<div *ngIf="(detailView !== undefined)">
  <div class="row detailViewerHeader">
    <div class="col-xs-12 text-center">
      <h5>Scheduled Resources For {{detailView.start.format('MM-DD-YYYY') + ' to ' + detailView.end.format('MM-DD-YYYY')}}</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 detailViewerBottom">
      <div *ngFor="let resource of detailView.scheduledResources">
        <span *ngIf="resource.color != null" [ngStyle]="{'background-color':resource.color}">&nbsp;&nbsp;&nbsp;</span>&nbsp;
        <a style="text-decoration:underline;cursor:pointer" (click)="showScheduleItem(resource)">{{resource.id}}</a>{{ ' '+ resource.name + " @ " + resource.siteCode + "-" + resource.resourceDescription + " " + m(resource.start).format('M/D/YY') + "-" + m(resource.end).format('M/D/YY') + ((resource.reliefForName != null) ? ' for - ' + insertCopa(resource) + insertOandA(resource) + resource.reliefForName : '') + ((resource.overhireJt != null) ? ' for - ' + insertCopa(resource) + insertOandA(resource) + resource.overhireJt : '') + ((resource.isVip && resource.scheduleItemStatusId != siStatus.pending) ? ' is a VIP': '') + ((resource.scheduleItemStatusId == siStatus.pending) ? ' is PENDING': '')}}
        <hr style="margin: 2px" />
      </div>
    </div>
  </div>
</div>

<aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>

